const translation = {
  nav: {
    home: "Strona główna",
    guide: "Poradnik Zakupowy",
    articles: "Artykuły SEO",
    categories: "Kategorie",
    navigation: "Nawigacja",
    kakobuySpreadsheet: "kakobuy spreadsheet",
    buyItNow: "buy it now",
  },
  hero: {
    title1: "Najlepszy",
    title2: "Kakobuy Spreadsheet",
    subtitle: "Kompletny przewodnik zakupowy dla Polski 2026",
    cta: "Przejdź do sklepu",
    ctaArticle: "Przeczytaj przewodnik",
  },
  categories: {
    title: "Przeglądaj kategorie",
    highlight: "Kakobuy",
    allCategories: "Wszystkie kategorie",
    viewAll: "Zobacz wszystkie",
  },
  about: {
    label: "Kakobuy Spreadsheet Guide",
    line1: "Odkryj najlepsze",
    line2: "produkty z Chin",
    line3: "dla Polski 2026",
  },
  featured: {
    title: "Polecane z spreadsheet",
    top: "TOP",
  },
  testimonial: {
    quote: "Kakobuy spreadsheet zaoszczędził mi setki złotych i eliminuje ryzyko błędnych zakupów. To absolutnie niezbędne narzędzie dla każdego, kto kupuje z Chin.",
    name: "Michał Kowalski",
    role: "Ekspert zakupowy z Chin",
    cta: "Więcej opinii",
  },
  article: {
    title1: "Kompletny przewodnik",
    title2: "kakobuy spreadsheet",
    title3: "dla Polski 2026",
    cta: "Przeczytaj artykuł SEO",
    readTime: "Czas czytania: 8 min",
    author: "Polski ekspert zakupowy",
    updated: "Ostatnia aktualizacja: czerwiec 2026",
  },
  articlesList: {
    heading: "Artykuły SEO — Kakobuy Spreadsheet",
    subheading: "Poznaj nasze szczegółowe przewodniki, rankingi i analizy dla użytkowników z Polski",
    readMore: "Czytaj więcej",
    minRead: "min czytania",
  },
  footer: {
    description: "Kompletny przewodnik po Kakobuy Spreadsheet. Rankingi kategorii, porównania produktów i bezpieczne zakupy z Chin dla użytkowników z Polski.",
    newsletter: "NEWSLETTER",
    newsletterPlaceholder: "Twój adres email",
    newsletterHint: "Otrzymuj najnowsze aktualizacje i poradniki",
    categories: "KATEGORIE",
    social: "SOCIAL",
    copyright: "© 2026 Kakobuy Yachts. Wszelkie prawa zastrzeżone.",
  },
};

export default translation;